import React from "react";
import { OnlinePresenceType } from "../../../../redux/auth/authTypes";
type AppProps = {
  data: OnlinePresenceType;
  isEdit?:boolean|string;
  onlinePresenc: (data: any) => void
  
};
const OnlinePresenc = ({ data,isEdit,onlinePresenc }: AppProps) => {
  return (
    <div className="form-group">
      <h6>ONLINE PRESENCE</h6>
      <div className="row">
        <div className="col-md-3">
          <label htmlFor="linkedinProfile">LinkedIn Profile</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="linkedin_profile"
              disabled={!isEdit}
              value={data?.linkedin_profile||""}
              onChange={onlinePresenc}
            />
          </div>
        </div>
        <div className="col-md-3">
          <label htmlFor="twitterId">Twitter ID</label>
          <div className="d-flex flex-row position-relative">
            <input
              type="text"
              className="form-control"
              name="twitter_id"
              disabled={!isEdit}
              value={data?.twitter_id||""}
              onChange={onlinePresenc}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnlinePresenc;
